import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import classes from "./PrivacySettings.module.css";
import PageLayout from "../../PageLayout/PageLayout";
import { Button } from "../../../../../stories/Button/Button";
import { Input } from "../../../../../stories/Input/Input";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Arrowlinkicon } from "../../../../../constant/imagePath";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import PrivacySettingsMobile from "./PrivacySettingsMobile";
import DisableAccountModal from "../../../../../components/Modals/CoachFlow/Settings/DisableAccount/DisableAccount";

const PrivacySettingsDesktop = () => {
  const [email, setEmail] = useState("abc@gmail.com");
  const [password, setPassword] = useState();
  const [newpassword, setNewPassword] = useState();
  const [confirmpassword, setConfirmPassword] = useState();
  const [disableModal, setDisableModal] = useState(false);

  return (
    <div className={[classes.PrivacySettingsScreen].join(" ")}>
      <Container fluid className={[classes.container, "p-0"].join(" ")}>
        <Row className={[classes.mb52, "g-0"].join(" ")}>
          <Col md={12}>
            <h3
              style={{
                ...Fonts.h3,
                color: Colors.neutralShadesOfNero,
              }}
            >
              Profile Settings
            </h3>
          </Col>
        </Row>

        <Row className={`g-0 ${classes.row}`}>
          <Col md={12}>
            <h5
              style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
              className={`${classes.mb16}`}
            >
              Email Address
            </h5>
            <p
              style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
              className={[classes.mb32].join(" ")}
            >
              Your email address is{" "}
              <span
                style={{ ...Fonts.h7, color: Colors.neutralShadesOfNero }}
                className={[classes.ml8].join(" ")}
              >
                {email}
              </span>
            </p>
          </Col>

          <Col md={6} className={[classes.mb80].join(" ")}>
            <Input
              type="email"
              state={email}
              setter={setEmail}
              label="Email Address"
              disabled={true}
            />
            {/* <div className={[classes.updatebtn, classes.mt32].join(" ")}>
              <Button primary={true} customStyle={{ width: "100%" }}>
                Update Email
              </Button>
            </div> */}
          </Col>
        </Row>

        <Row className={[classes.mb32, "g-0"].join(" ")}>
          <Col md={6}>
            <h5
              style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
              className={`${classes.mb32}`}
            >
              Password
            </h5>
            <Input
              type="password"
              state={password}
              setter={setPassword}
              label="Current password"
              placeholder={"Enter current password"}
            />
          </Col>
        </Row>

        <Row className={[classes.mb32].join(" ")}>
          <Col md={6}>
            <Input
              type="password"
              state={newpassword}
              setter={setNewPassword}
              label="New password"
              placeholder={"Enter new password"}
            />
          </Col>

          <Col md={6}>
            <Input
              type="password"
              state={confirmpassword}
              setter={setConfirmPassword}
              label="Confirm New password"
              placeholder={"Re-enter new password"}
            />
          </Col>
        </Row>
        <div className={[classes.btndiv, classes.pb24, classes.mb24].join(" ")}>
          <div className={[classes.saveAndCancelbtn].join(" ")}>
            <Button primary={false} customStyle={{ width: "100%" }}>
              Cancel
            </Button>
          </div>
          <div className={[classes.saveAndCancelbtn, classes.ml16].join(" ")}>
            <Button primary={true} customStyle={{ width: "100%" }}>
              Save changes
            </Button>
          </div>
        </div>
        <div className={[classes.dflex, classes.mb80].join(" ")}>
          <p
            style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
            className={[classes.mr10].join(" ")}
          >
            Can't remember your current password?
          </p>
          <LinkButtonWithIcon
            rightIcon={Arrowlinkicon}
            text="Reset password via email"
            primary={true}
            customStyle={{
              ...Fonts.p1,
              fontSize: "16px",
              lineHeight: "16px",
            }}
          />
        </div>

        <Row className={[classes.mb56, "g-0"].join(" ")}>
          <Col md={6}>
            <h5
              style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
              className={`${classes.mb12}`}
            >
              Disable account
            </h5>
            <p
              style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
              className={[classes.mb24].join(" ")}
            >
              <span style={{ color: Colors.errorColor, ...Fonts.h7 }}>
                PLEASE NOTE!
              </span>{" "}
              This means your account will be hidden until you reactivate it by
              logging back in.
            </p>
            <div className={[classes.disablebtnwidth].join(" ")}>
              <Button
                primary={false}
                onClick={() => setDisableModal(!disableModal)}
                customStyle={{ width: "max-content" }}
              >
                Disable the account
              </Button>
            </div>
          </Col>
        </Row>

        <DisableAccountModal show={disableModal} setShow={setDisableModal} />
      </Container>
    </div>
  );
};

const PrivacySettings = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <PrivacySettingsMobile /> : <PrivacySettingsDesktop />;
};

export default PrivacySettings;
